export default {
  title: 'Oferte Exclusive',
  header: {
    back: 'Înapoi',
    title: 'Recompense',
  },
  info: {
    title: 'Ai {{points}} puncte.',
    description: 'Cheltuiește {{amount}} pentru 5 puncte! Adaugă articole gratuit în coș cu punctele câștigate.',
  },
  rewards: {
    data: [
      {
        title: 'Câștigă Puncte pentru Fiecare Comandă',
        description: 'Fiecare {{amount}} cheltuit adaugă 5 puncte în contul tău.',
      },
      {
        title: 'Câștigă Puncte pentru Fiecare Comandă',
        description:
          'Răscumpără punctele pentru produse gratuite! Începe să câștige de la 350 de puncte, echivalent cu cheltuirea {{amount}}.',
      },
      {
        title: 'Câștigă Puncte pentru Fiecare Comandă',
        description:
          'Descoperă oferte exclusive, promoții și reduceri. Vezi promoțiile exclusiv pentru membri în aplicație.',
      },
    ],
  },
};
